import React from 'react';
import { TruncatedText } from '@td-client-frontend/common';

export function Td({ children }: { children: React.ReactNode }) {
  const childrenToRender = typeof children === 'string' ? <TruncatedText label={children} /> : children;

  return (
    <td className="px-4 py-5 text-sm font-effra text-black-default" data-testid="td-component">
      {childrenToRender}
    </td>
  );
}
